import { render, staticRenderFns } from "./tax-offices-icon.vue?vue&type=template&id=8afc8c90"
import script from "./tax-offices-icon.vue?vue&type=script&lang=js"
export * from "./tax-offices-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports